module.exports = __webpack_public_path__ + "static/media/sa-sm-off.e6127e18.png";